export const formatProfileText = (value) => {
  if (Array.isArray(value)) {
    return value.map(formatProfileText).filter(Boolean).join(', ');
  }

  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value !== 'string') {
    return String(value);
  }

  const text = value.trim();
  if (!text) {
    return '';
  }

  try {
    const parsed = JSON.parse(text);
    if (Array.isArray(parsed)) {
      return formatProfileText(parsed);
    }
  } catch {
    // Treat non-JSON text as regular profile copy.
  }

  return text
    .replace(/\s*,\s*/g, ', ')
    .replace(/\s+/g, ' ')
    .replace(/\bGoddessIman\b/g, 'Goddess Iman')
    .replace(/([.!?])([A-Z])/g, '$1 $2');
};

export const formatPractitionerName = (value) => formatProfileText(value);
